import { render } from "./ListDataWish.vue?vue&type=template&id=d663a562"
import script from "./ListDataWish.vue?vue&type=script&lang=js"
export * from "./ListDataWish.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__